const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreFront(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 602 551",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 17.229,
    y: 369.513,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.258,
    y: 369.513,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.283,
    y: 369.513,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.308,
    y: 369.513,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.333,
    y: 369.513,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.363,
    y: 369.513,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.387,
    y: 369.513,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.412,
    y: 369.513,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.442,
    y: 369.513,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.467,
    y: 369.513,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.329,
    y: 321.142,
    width: 103.058,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.783,
    y: 321.142,
    width: 8.904,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.971,
    y: 321.142,
    width: 8.9,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.754,
    y: 283.708,
    width: 92.475,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.525,
    y: 316.321,
    width: 92.471,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.667,
    y: 134.113,
    width: 419.108,
    height: 414.121,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.05,
    y: 196.954,
    width: 350.517,
    height: 84.979,
    style: {
      fill: "#f24385",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.667,
    y: 134.113,
    width: 419.108,
    height: 35.917,
    style: {
      fill: "#e7e7e8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.75,546.15l414.942,0l-0,-409.954l-414.942,-0l0,409.954Zm419.108,4.167l-423.275,-0l0,-418.288l423.275,0l0,418.288Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.667,
    y: 167.946,
    width: 419.108,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8,152.071c0,2 -1.621,3.621 -3.621,3.621c-2,-0 -3.625,-1.621 -3.625,-3.621c0,-2 1.625,-3.621 3.625,-3.621c2,-0 3.621,1.621 3.621,3.621Z",
    style: {
      fill: "#e8643e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.067,152.071c-0,2 -1.621,3.621 -3.621,3.621c-2.004,-0 -3.625,-1.621 -3.625,-3.621c-0,-2 1.621,-3.621 3.625,-3.621c2,-0 3.621,1.621 3.621,3.621Z",
    style: {
      fill: "#50c5d2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.333,152.071c0,2 -1.625,3.621 -3.625,3.621c-2,-0 -3.62,-1.621 -3.62,-3.621c-0,-2 1.62,-3.621 3.62,-3.621c2,-0 3.625,1.621 3.625,3.621Z",
    style: {
      fill: "#f6ab33",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.113,
    y: 148.45,
    width: 286.738,
    height: 7.242,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.867,
    y: 402.771,
    width: 81.308,
    height: 136.175,
    style: {
      fill: "#50c5d2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.325,
    y: 402.771,
    width: 129.246,
    height: 96.788,
    style: {
      fill: "#50c5d2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.05,
    y: 402.771,
    width: 120.292,
    height: 96.788,
    style: {
      fill: "#50c5d2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.958,475.675c0,3.112 -2.521,5.638 -5.637,5.638c-3.113,-0 -5.634,-2.526 -5.634,-5.638c0,-3.112 2.521,-5.638 5.634,-5.638c3.116,0 5.637,2.526 5.637,5.638Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.258,
    y: 360.192,
    width: 174.583,
    height: 22.808,
    style: {
      fill: "#f24385",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.338,380.917l170.42,-0l0,-18.642l-170.42,0l-0,18.642Zm174.587,4.166l-178.754,0l-0,-26.975l178.754,0l0,26.975Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.583,317.192l9.692,-14.142l406.863,-0l6.72,15.354l-423.275,-1.212Z",
    style: {
      fill: "#f24385",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.95,319.238l-6.175,-14.105l-404.404,0l-9.071,13.238l-3.437,-2.354l10.312,-15.05l409.321,-0l7.271,16.6l-3.817,1.671Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.654,
    y: 497.475,
    width: 134.592,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.729,347.679c-10.529,0 -19.146,-8.616 -19.146,-19.142l0,-10.133l38.292,0l-0,10.133c-0,10.526 -8.617,19.142 -19.146,19.142Z",
    style: {
      fill: "#f24385",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.021,347.679c-10.533,0 -19.146,-8.616 -19.146,-19.142l-0,-10.133l38.288,0l-0,10.133c-0,10.526 -8.617,19.142 -19.142,19.142Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.308,347.679c-10.529,0 -19.145,-8.616 -19.145,-19.142l-0,-10.133l38.291,0l0,10.133c0,10.526 -8.616,19.142 -19.146,19.142Z",
    style: {
      fill: "#f24385",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6,347.679c-10.529,0 -19.146,-8.616 -19.146,-19.142l0,-10.133l38.292,0l-0,10.133c-0,10.526 -8.617,19.142 -19.146,19.142Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.892,347.679c-10.534,0 -19.146,-8.616 -19.146,-19.142l-0,-10.133l38.292,0l-0,10.133c-0,10.526 -8.617,19.142 -19.146,19.142Z",
    style: {
      fill: "#f24385",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.183,347.679c-10.529,0 -19.145,-8.616 -19.145,-19.142l-0,-10.133l38.291,0l0,10.133c0,10.526 -8.616,19.142 -19.146,19.142Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.475,347.679c-10.533,0 -19.146,-8.616 -19.146,-19.142l0,-10.133l38.288,0l-0,10.133c-0,10.526 -8.613,19.142 -19.142,19.142Z",
    style: {
      fill: "#f24385",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.763,347.679c-10.53,0 -19.146,-8.616 -19.146,-19.142l-0,-10.133l38.291,0l0,10.133c0,10.526 -8.616,19.142 -19.145,19.142Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.054,347.679c-10.529,0 -19.146,-8.616 -19.146,-19.142l0,-10.133l38.292,0l0,10.133c0,10.526 -8.617,19.142 -19.146,19.142Z",
    style: {
      fill: "#f24385",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.346,347.679c-10.533,0 -19.146,-8.616 -19.146,-19.142l0,-10.133l38.287,0l0,10.133c0,10.526 -8.612,19.142 -19.141,19.142Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.712,347.679c-10.529,0 -19.145,-8.616 -19.145,-19.142l-0,-10.133l38.291,0l0,10.133c0,10.526 -8.616,19.142 -19.146,19.142Z",
    style: {
      fill: "#f24385",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.667,320.487l-0,8.05c-0,9.409 7.654,17.059 17.058,17.059c9.413,-0 17.067,-7.65 17.067,-17.059l-0,-8.05l-34.125,0Zm17.058,29.275c-11.704,0 -21.225,-9.52 -21.225,-21.225l0,-12.216l42.458,-0l0,12.216c0,11.705 -9.525,21.225 -21.233,21.225Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.958,320.487l0,8.05c0,9.409 7.65,17.059 17.059,17.059c9.412,-0 17.066,-7.65 17.066,-17.059l0,-8.05l-34.125,0Zm17.059,29.275c-11.704,0 -21.225,-9.52 -21.225,-21.225l-0,-12.216l42.458,-0l0,12.216c0,11.705 -9.525,21.225 -21.233,21.225Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.25,320.487l0,8.05c0,9.409 7.65,17.059 17.058,17.059c9.409,-0 17.063,-7.65 17.063,-17.059l-0,-8.05l-34.121,0Zm17.058,29.275c-11.704,0 -21.225,-9.52 -21.225,-21.225l0,-12.216l42.455,-0l-0,12.216c-0,11.705 -9.525,21.225 -21.23,21.225Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.538,320.487l-0,8.05c-0,9.409 7.654,17.059 17.062,17.059c9.408,-0 17.062,-7.65 17.062,-17.059l0,-8.05l-34.124,0Zm17.062,29.275c-11.704,0 -21.229,-9.52 -21.229,-21.225l-0,-12.216l42.458,-0l0,12.216c0,11.705 -9.525,21.225 -21.229,21.225Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.829,320.487l0,8.05c0,9.409 7.654,17.059 17.063,17.059c9.408,-0 17.062,-7.65 17.062,-17.059l0,-8.05l-34.125,0Zm17.063,29.275c-11.704,0 -21.23,-9.52 -21.23,-21.225l0,-12.216l42.459,-0l-0,12.216c-0,11.705 -9.525,21.225 -21.229,21.225Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.121,320.487l-0,8.05c-0,9.409 7.654,17.059 17.062,17.059c9.409,-0 17.063,-7.65 17.063,-17.059l-0,-8.05l-34.125,0Zm17.062,29.275c-11.708,0 -21.229,-9.52 -21.229,-21.225l0,-12.216l42.459,-0l-0,12.216c-0,11.705 -9.525,21.225 -21.23,21.225Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.413,320.487l-0,8.05c-0,9.409 7.654,17.059 17.058,17.059c9.408,-0 17.062,-7.65 17.062,-17.059l0,-8.05l-34.12,0Zm17.058,29.275c-11.704,0 -21.225,-9.52 -21.225,-21.225l-0,-12.216l42.454,-0l-0,12.216c-0,11.705 -9.521,21.225 -21.229,21.225Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.7,320.487l-0,8.05c-0,9.409 7.654,17.059 17.063,17.059c9.404,-0 17.062,-7.65 17.062,-17.059l0,-8.05l-34.125,0Zm17.063,29.275c-11.705,0 -21.23,-9.52 -21.23,-21.225l0,-12.216l42.459,-0l-0,12.216c-0,11.705 -9.521,21.225 -21.229,21.225Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.992,320.487l-0,8.05c-0,9.409 7.654,17.059 17.062,17.059c9.408,-0 17.063,-7.65 17.063,-17.059l-0,-8.05l-34.125,0Zm17.062,29.275c-11.704,0 -21.229,-9.52 -21.229,-21.225l0,-12.216l42.458,-0l0,12.216c0,11.705 -9.525,21.225 -21.229,21.225Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.283,320.487l0,8.05c0,9.409 7.654,17.059 17.063,17.059c9.408,-0 17.062,-7.65 17.062,-17.059l0,-8.05l-34.125,0Zm17.063,29.275c-11.708,0 -21.229,-9.52 -21.229,-21.225l-0,-12.216l42.458,-0l0,12.216c0,11.705 -9.525,21.225 -21.229,21.225Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.65,320.487l0,8.05c0,9.409 7.654,17.059 17.062,17.059c9.409,-0 17.063,-7.65 17.063,-17.059l-0,-8.05l-34.125,0Zm17.062,29.275c-11.704,0 -21.229,-9.52 -21.229,-21.225l0,-12.216l42.459,-0l-0,12.216c-0,11.705 -9.525,21.225 -21.23,21.225Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.279,
    y: 497.475,
    width: 134.592,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.692,464.704l-40.325,-25.275l11.045,46.267l6.225,-13.892l12.884,16.775l7.025,-5.166l-13.113,-17.13l16.259,-1.579Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.283,
    y: 406.592,
    width: 4.167,
    height: 15.704,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.963,427.629l-3.192,-2.675l10.079,-12.037l3.196,2.67l-10.083,12.042Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.6,438.471l-0.733,-4.104l15.462,-2.759l0.733,4.1l-15.462,2.763Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.267,471.05l-3.925,-1.404l5.291,-14.784l3.921,1.405l-5.287,14.783Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.092,457.829l-2.109,-3.592l13.55,-7.941l2.109,3.596l-13.55,7.937Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.125,438.638l-15.488,-2.609l0.696,-4.108l15.48,2.608l-0.688,4.109Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.654,427.754l-10.2,-11.941l3.171,-2.705l10.2,11.938l-3.171,2.708Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.533,232.246c0,-4.454 -3.612,-8.063 -8.062,-8.063c-1.233,0 -2.371,0.325 -3.417,0.821c-1.525,-3.133 -4.429,-5.304 -7.925,-6.042c0.15,-0.808 0.483,-1.554 0.483,-2.404c0,-7.412 -6.004,-13.416 -13.412,-13.416c-3.508,-0 -6.642,1.421 -9.033,3.625c-0.9,-12.796 -11.454,-22.929 -24.479,-22.929c-11.317,-0 -20.755,7.675 -23.646,18.07c-1.088,-0.216 -2.213,-0.337 -3.367,-0.337c-7.85,-0 -14.392,5.371 -16.304,12.621c-1.767,-0.705 -3.675,-1.146 -5.692,-1.146c-8.496,-0 -15.387,6.887 -15.387,15.387c-0,2.875 1.004,5.421 2.383,7.725l126.7,0c0.671,-1.175 1.158,-2.466 1.158,-3.912Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.333,
    y: 234.075,
    width: 93.196,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.096,
    y: 234.075,
    width: 27.646,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.308,204.983c8.059,0 14.655,6.596 14.655,14.65c-0,1.663 -0.342,3.234 -0.859,4.725c1.542,-2.316 2.454,-5.087 2.454,-8.062c0,-8.059 -6.595,-14.654 -14.654,-14.654c-6.396,-0 -11.808,4.183 -13.796,9.929c2.634,-3.959 7.121,-6.588 12.2,-6.588Z",
    style: {
      fill: "#bdbec0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.912,220.896c-3.604,2.55 -8.641,1.683 -11.191,-1.925c-0.525,-0.742 -0.871,-1.554 -1.113,-2.383c0.046,1.525 0.517,3.054 1.455,4.383c2.55,3.608 7.587,4.475 11.195,1.925c2.863,-2.025 3.963,-5.608 3.034,-8.808c0.075,2.604 -1.104,5.199 -3.38,6.808Z",
    style: {
      fill: "#bdbec0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.696,216.558l-4.167,0c0,-6.25 -5.083,-11.333 -11.329,-11.333c-2.767,-0 -5.475,1.092 -7.617,3.071l-3.191,2.946l-0.3,-4.33c-0.834,-11.77 -10.671,-20.991 -22.404,-20.991c-10.03,-0 -18.93,6.804 -21.642,16.546l-4.013,-1.117c3.213,-11.538 13.763,-19.596 25.655,-19.596c12.7,0 23.525,9.1 26.062,21.292c2.287,-1.296 4.842,-1.988 7.45,-1.988c8.546,0 15.496,6.955 15.496,15.5Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.404,207.829c0,-4.492 -3.641,-8.133 -8.129,-8.133c-1.246,-0 -2.392,0.329 -3.446,0.829c-1.541,-3.158 -4.466,-5.346 -7.996,-6.096c0.154,-0.812 0.488,-1.562 0.488,-2.425c-0,-7.471 -6.054,-13.529 -13.529,-13.529c-3.538,0 -6.7,1.433 -9.109,3.654c-0.908,-12.904 -11.554,-23.125 -24.691,-23.125c-11.417,0 -20.934,7.742 -23.855,18.229c-1.095,-0.22 -2.229,-0.341 -3.391,-0.341c-7.921,-0 -14.517,5.416 -16.446,12.729c-1.779,-0.713 -3.704,-1.158 -5.742,-1.158c-8.571,-0 -15.521,6.95 -15.521,15.52c0,2.905 1.017,5.467 2.405,7.792l127.796,0c0.675,-1.187 1.166,-2.483 1.166,-3.946Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.4,
    y: 209.692,
    width: 94.004,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.867,
    y: 209.692,
    width: 27.883,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.358,180.333c8.13,0 14.78,6.65 14.78,14.779c-0,1.676 -0.342,3.259 -0.863,4.763c1.554,-2.338 2.471,-5.133 2.471,-8.133c-0,-8.129 -6.65,-14.779 -14.779,-14.779c-6.45,-0 -11.913,4.216 -13.913,10.012c2.654,-3.992 7.179,-6.642 12.304,-6.642Z",
    style: {
      fill: "#bdbec0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.592,196.383c-3.638,2.571 -8.721,1.696 -11.292,-1.941c-0.529,-0.75 -0.875,-1.567 -1.121,-2.405c0.046,1.538 0.517,3.08 1.467,4.421c2.571,3.638 7.65,4.513 11.292,1.942c2.887,-2.042 3.995,-5.658 3.058,-8.883c0.075,2.625 -1.113,5.241 -3.404,6.866Z",
    style: {
      fill: "#bdbec0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.404,192.004l-4.167,0c0,-6.312 -5.133,-11.446 -11.445,-11.446c-2.792,0 -5.529,1.104 -7.7,3.105l-3.184,2.937l-0.304,-4.321c-0.837,-11.883 -10.771,-21.191 -22.612,-21.191c-10.125,-0 -19.109,6.866 -21.846,16.7l-4.013,-1.113c3.234,-11.633 13.871,-19.754 25.859,-19.754c12.808,-0 23.725,9.183 26.275,21.483c2.308,-1.312 4.891,-2.012 7.525,-2.012c8.608,-0 15.612,7.004 15.612,15.612Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.267,111.842c-0,-3.517 -2.85,-6.367 -6.363,-6.367c-0.975,-0 -1.871,0.258 -2.7,0.646c-1.204,-2.471 -3.496,-4.184 -6.258,-4.771c0.121,-0.638 0.383,-1.225 0.383,-1.896c0,-5.85 -4.741,-10.592 -10.591,-10.592c-2.767,0 -5.246,1.121 -7.134,2.863c-0.708,-10.104 -9.042,-18.108 -19.325,-18.108c-8.937,-0 -16.387,6.062 -18.675,14.271c-0.858,-0.171 -1.746,-0.267 -2.654,-0.267c-6.2,-0 -11.362,4.241 -12.875,9.966c-1.392,-0.558 -2.9,-0.908 -4.496,-0.908c-6.708,0 -12.146,5.442 -12.146,12.15c0,2.271 0.792,4.279 1.88,6.1l100.041,0c0.529,-0.929 0.913,-1.946 0.913,-3.087Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.679,
    y: 112.846,
    width: 73.588,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.646,
    y: 112.846,
    width: 21.829,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.083,90.317c6.363,-0 11.567,5.204 11.567,11.566c0,1.313 -0.267,2.555 -0.675,3.73c1.217,-1.83 1.933,-4.017 1.933,-6.367c0,-6.363 -5.204,-11.571 -11.566,-11.571c-5.05,-0 -9.325,3.304 -10.892,7.842c2.075,-3.125 5.621,-5.2 9.633,-5.2Z",
    style: {
      fill: "#bdbec0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.408,102.879c-2.85,2.013 -6.825,1.329 -8.837,-1.521c-0.413,-0.583 -0.688,-1.225 -0.879,-1.883c0.037,1.204 0.408,2.413 1.15,3.463c2.012,2.85 5.987,3.533 8.837,1.52c2.263,-1.595 3.129,-4.429 2.396,-6.954c0.058,2.054 -0.871,4.104 -2.667,5.375Z",
    style: {
      fill: "#bdbec0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.413,99.454l-4.167,0c-0,-4.691 -3.817,-8.508 -8.508,-8.508c-2.655,-0 -4.575,1.254 -5.721,2.308l-3.184,2.942l-0.304,-4.325c-0.641,-9.067 -8.216,-16.167 -17.25,-16.167c-7.725,0 -14.579,5.238 -16.666,12.742l-4.013,-1.117c2.588,-9.3 11.088,-15.791 20.679,-15.791c10.034,-0 18.621,7.049 20.879,16.587c1.738,-0.879 3.642,-1.346 5.58,-1.346c6.987,0 12.675,5.684 12.675,12.675Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.158,
    y: 443.954,
    width: 89.142,
    height: 89.775,
    style: {
      fill: "#fad25a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.3,533.729l-89.142,0l-2.179,14.504l93.496,0l-2.175,-14.504Z",
    style: {
      fill: "#f6ab33",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.688,458.579c-0,2.717 -2.2,4.917 -4.917,4.917c-2.713,-0 -4.917,-2.2 -4.917,-4.917c0,-2.712 2.204,-4.912 4.917,-4.912c2.717,-0 4.917,2.2 4.917,4.912Z",
    style: {
      fill: "#b7802b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.6,458.579c-0,2.717 -2.2,4.917 -4.917,4.917c-2.716,-0 -4.916,-2.2 -4.916,-4.917c-0,-2.712 2.2,-4.912 4.916,-4.912c2.717,-0 4.917,2.2 4.917,4.912Z",
    style: {
      fill: "#b7802b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.767,460.758l-4.167,0l0,-12.608c0,-14.267 -11.604,-25.875 -25.871,-25.875c-14.266,0 -25.875,11.608 -25.875,25.875l0,12.608l-4.166,0l-0,-12.608c-0,-16.563 13.479,-30.042 30.041,-30.042c16.563,0 30.038,13.479 30.038,30.042l-0,12.608Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.704,
    y: 546.15,
    width: 499.4,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.188,58.908c-0,22.021 -17.855,39.875 -39.88,39.875c-22.02,0 -39.875,-17.854 -39.875,-39.875c0,-22.025 17.855,-39.875 39.875,-39.875c22.025,0 39.88,17.85 39.88,39.875Z",
    style: {
      fill: "#fad25a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.771,
    y: 7.063,
    width: 4.167,
    height: 9.496,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.175,20.196l-3.912,-1.429l6.504,-17.838l3.912,1.425l-6.504,17.842Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.342,28.446l-3.259,-2.596l6.113,-7.667l3.258,2.596l-6.112,7.667Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.867,40.438l-2.079,-3.617l16.462,-9.463l2.075,3.613l-16.458,9.467Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.808,54.592l-0.712,-4.104l9.358,-1.626l0.709,4.105l-9.355,1.625Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.358,72.596l-18.687,-3.35l0.737,-4.104l18.688,3.354l-0.738,4.1Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.008,88.108l-9.429,-5.487l2.096,-3.604l9.429,5.487l-2.096,3.604Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.421,107.692l-12.146,-14.596l3.2,-2.663l12.15,14.592l-3.204,2.667Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.746,107.063l-2.742,-7.65l3.921,-1.409l2.746,7.65l-3.925,1.409Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.446,119.808l-4.167,-0.021l0.096,-18.987l4.167,0.021l-0.096,18.987Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.896,107.083l-3.909,-1.45l3.163,-8.541l3.908,1.446l-3.162,8.545Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.942,105.904l-3.175,-2.7l12.295,-14.471l3.176,2.7l-12.296,14.471Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.371,85.058l-2.058,-3.625l8.254,-4.687l2.058,3.621l-8.254,4.691Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.658,69.838l-0.691,-4.113l18.72,-3.158l0.692,4.112l-18.721,3.159Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.15,52.017l-9.337,-1.721l0.758,-4.096l9.333,1.721l-0.754,4.096Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.954,38.167l-16.366,-9.63l2.112,-3.591l16.367,9.633l-2.113,3.588Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.208,26.8l-6.037,-7.325l3.217,-2.65l6.037,7.325l-3.217,2.65Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.796,19.292l-6.321,-17.904l3.929,-1.388l6.325,17.904l-3.933,1.388Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.837,32.821l-4.166,-0c-0.138,-0.15 -1.079,-0.608 -1.638,-0.883c-1.583,-0.775 -3.966,-1.951 -3.966,-4.626c-0,-2.675 2.383,-3.845 3.966,-4.624c0.559,-0.276 1.5,-0.734 1.671,-1.005c-0.171,-0.025 -1.108,-0.487 -1.671,-0.758c-1.579,-0.775 -3.966,-1.95 -3.966,-4.621c-0,-2.675 2.387,-3.846 3.966,-4.621c0.563,-0.275 1.5,-0.733 1.671,-1l4.133,0.121c0,2.675 -2.387,3.846 -3.97,4.621c-0.559,0.275 -1.496,0.733 -1.671,1c0.175,0.021 1.112,0.483 1.675,0.758c1.579,0.775 3.966,1.946 3.966,4.621c0,2.675 -2.387,3.846 -3.966,4.625c-0.563,0.275 -1.5,0.738 -1.675,1.004c0.175,0.025 1.112,0.488 1.675,0.763c1.579,0.775 3.966,1.95 3.966,4.625Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.287,261.463l-4.166,-0c-0.138,-0.151 -1.075,-0.613 -1.638,-0.888c-1.579,-0.775 -3.966,-1.95 -3.966,-4.625c-0,-2.675 2.387,-3.846 3.966,-4.625c0.563,-0.271 1.5,-0.733 1.675,-1.004c-0.175,-0.025 -1.112,-0.484 -1.671,-0.758c-1.583,-0.775 -3.97,-1.946 -3.97,-4.621c-0,-2.671 2.387,-3.842 3.966,-4.617c0.563,-0.275 1.5,-0.733 1.675,-1l4.129,0.121c0,2.671 -2.387,3.846 -3.966,4.617c-0.559,0.274 -1.5,0.737 -1.671,1.004c0.171,0.021 1.112,0.483 1.671,0.758c1.579,0.775 3.966,1.942 3.966,4.617c0,2.675 -2.383,3.845 -3.966,4.625c-0.559,0.275 -1.5,0.737 -1.671,1.004c0.171,0.029 1.112,0.492 1.671,0.766c1.583,0.775 3.966,1.946 3.966,4.626Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.704,108.187c-1.166,0 -2.116,0.95 -2.116,2.117c-0,1.167 0.95,2.117 2.116,2.117c1.167,-0 2.113,-0.95 2.113,-2.117c-0,-1.167 -0.946,-2.117 -2.113,-2.117Zm0,8.401c-3.462,-0 -6.283,-2.821 -6.283,-6.284c-0,-3.462 2.821,-6.283 6.283,-6.283c3.463,-0 6.279,2.821 6.279,6.283c0,3.463 -2.816,6.284 -6.279,6.284Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.729,104.242c-1.166,-0 -2.116,0.95 -2.116,2.116c-0,1.167 0.95,2.117 2.116,2.117c1.167,-0 2.113,-0.95 2.113,-2.117c-0,-1.166 -0.946,-2.116 -2.113,-2.116Zm0,8.4c-3.467,-0 -6.283,-2.821 -6.283,-6.284c-0,-3.466 2.816,-6.283 6.283,-6.283c3.463,0 6.279,2.817 6.279,6.283c0,3.463 -2.816,6.284 -6.279,6.284Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.204,283.675c-1.162,0 -2.112,0.95 -2.112,2.117c-0,1.166 0.95,2.116 2.112,2.116c1.167,0 2.117,-0.95 2.117,-2.116c-0,-1.167 -0.95,-2.117 -2.117,-2.117Zm0,8.4c-3.462,-0 -6.279,-2.821 -6.279,-6.283c0,-3.463 2.817,-6.284 6.279,-6.284c3.467,0 6.284,2.821 6.284,6.284c-0,3.462 -2.817,6.283 -6.284,6.283Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.167,278.313l-0,14.958l12.958,-7.479l-12.958,-7.479Zm-4.167,22.179l0,-29.396l25.458,14.696l-25.458,14.7Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.754,48.675l0,3.192l2.767,-1.596l-2.767,-1.596Zm-4.166,10.408l-0,-17.629l15.266,8.817l-15.266,8.812Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.258,273.196l4.5,2.596l0,-5.196l-4.5,2.6Zm8.667,9.812l-17,-9.812l17,-9.817l0,19.629Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.233,80.9l4.496,2.596l0,-5.192l-4.496,2.596Zm8.663,9.817l-16.996,-9.817l16.996,-9.812l-0,19.629Z",
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.546,
    y: 78.738,
    width: 103.058,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 78.738,
    width: 8.904,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.187,
    y: 78.738,
    width: 8.9,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.113,
    y: 48.313,
    width: 15.162,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.608,
    y: 42.812,
    width: 4.167,
    height: 15.163,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.542,
    y: 135.396,
    width: 10.987,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.954,
    y: 131.988,
    width: 4.167,
    height: 10.987,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.362,
    y: 369.513,
    width: 10.992,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521.775,
    y: 366.1,
    width: 4.167,
    height: 10.992,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.733,
    y: 316.321,
    width: 10.992,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.146,
    y: 312.908,
    width: 4.167,
    height: 10.988,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.196,
    y: 48.313,
    width: 92.475,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.292,
    y: 104.275,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.317,
    y: 104.275,
    width: 4.983,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.342,
    y: 104.275,
    width: 4.983,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.371,
    y: 104.275,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.396,
    y: 104.275,
    width: 4.983,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.421,
    y: 104.275,
    width: 4.983,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.45,
    y: 104.275,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.475,
    y: 104.275,
    width: 4.979,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.5,
    y: 104.275,
    width: 4.983,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.525,
    y: 104.275,
    width: 4.983,
    height: 4.167,
    style: {
      fill: "#414043",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreFront);
export default __webpack_public_path__ + "static/media/StoreFront.af3f7003358a6a9c45aafad080d412e3.svg";
export { ForwardRef as ReactComponent };